<mat-icon matSuffix class="secondary-text" click-stop-propagation (click)="showInfoDialog()" style="cursor: pointer;">info</mat-icon>
